import { render, staticRenderFns } from "./property-ad-card.vue?vue&type=template&id=eef0a7d8&scoped=true"
import script from "./property-ad-card.vue?vue&type=script&lang=js"
export * from "./property-ad-card.vue?vue&type=script&lang=js"
import style0 from "./property-ad-card.vue?vue&type=style&index=0&id=eef0a7d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef0a7d8",
  null
  
)

export default component.exports